import React, { useEffect, useState } from 'react'
import { Button, Cell, Divider, Grid, TextField } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { DmcDatePicker } from '../../common/DmcDatePicker/DmcDatePicker'

export default function OdmSubmissionForm({ handleSubmit, location, history }) {
  const searchParams = new URLSearchParams(location.search)
  const { t } = useTranslation()
  const initialState = {
    barCode: '',
    birthDate: '',
    givenName: '',
    submissionNbr: '',
    surname: '',
  }
  const [query, setQuery] = useState({
    barCode: searchParams.get('barCode') || '',
    birthDate: searchParams.get('birthDate') || '',
    givenName: searchParams.get('givenName') || '',
    submissionNbr: searchParams.get('submissionNbr') || '',
    surname: searchParams.get('surname') || '',
  })
  const [birthDate, setBirthDate] = useState({
    key: 'date',
    primaryText: query.birthDate,
  })

  const isEqual = (obj1, obj2) => {
    return (
      obj1.barCode === obj2.barCode &&
      obj1.birthDate === obj2.birthDate &&
      obj1.givenName === obj2.givenName &&
      obj1.submissionNbr === obj2.submissionNbr &&
      obj1.surname === obj2.surname
    )
  }

  useEffect(() => {
    if (query.birthDate) {
      birthDate.primaryText = `${query.day} ${query.month} ${query.year}`
      setBirthDate(birthDate)
    }

    if (!isEqual(query, initialState)) {
      handleSubmit(query)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search])

  const submit = (event) => {
    event.preventDefault()
    let queryString = `search=odmSubmission`

    Object.keys(query).forEach((queryKey) => {
      if (query[queryKey] !== initialState[queryKey]) {
        queryString += `&${queryKey}=${query[queryKey]}`
      }
    })

    if (queryString !== `search=odmSubmission`) {
      history.push(`/search/odv?${queryString}`)
    }
  }

  const setDate = (value) => {
    if (value) {
      setBirthDate(value)
      setQuery({ ...query, birthDate: value.primaryText })
    } else {
      birthDate.primaryText = ''
      setBirthDate(birthDate)
      setQuery({ ...query, birthDate: '' })
    }
  }

  const reset = () => {
    setQuery(initialState)
    setBirthDate({
      key: 'date',
      primaryText: '',
    })
    handleSubmit(null)
  }

  return (
    <form onSubmit={(event) => submit(event)}>
      <Divider label={t('submitter', 'Submitter')} />
      <Grid>
        <Cell columns={4}>
          <TextField
            id="odmSubmissionGivenName"
            label={t('givenName', 'Given Name')}
            value={query.givenName}
            onChange={(event) => setQuery({ ...query, givenName: event.target.value })}
          />
        </Cell>
        <Cell columns={4}>
          <TextField
            label={t('name.parts.surname', 'Surname')}
            value={query.surname}
            onChange={(event) => setQuery({ ...query, surname: event.target.value })}
          />
        </Cell>
        <Cell columns={4}>
          <DmcDatePicker
            idType="odmSubmissionBirth"
            selectedItem={birthDate}
            setSelectedItem={setDate}
            label={t('birthDate', 'Birth Date')}
            dayMonthYearDateFormat="yyyyMMDD"
            monthYearDateFormat="yyyy"
            yearDateFormat="yyyy"
          />
        </Cell>
        <Divider />
        <Cell columns={6}>
          <TextField
            label={t('submissionNumber', 'Submission Number')}
            value={query.submissionNbr}
            onChange={(event) => setQuery({ ...query, submissionNbr: event.target.value })}
          />
        </Cell>
        <Cell columns={6}>
          <TextField
            label={t('barcode', 'Barcode')}
            value={query.barCode}
            onChange={(event) => setQuery({ ...query, barCode: event.target.value })}
          />
        </Cell>
        <Cell columns={1}>
          <Button id="odvSearchBtn" type="submit" emphasis="high">
            {t('action.search', 'Search')}
          </Button>
        </Cell>
        <Cell columns={11}>
          <Button emphasis="medium" onClick={reset}>
            {t('action.clear', 'Clear')}
          </Button>
        </Cell>
      </Grid>
    </form>
  )
}
